export const MAX_COLLAPSED_ITEMS = 5;
export const MAX_LABEL_ITEMS = 5;
export const MAX_PAGE_ITEMS = 5;
